import { render, staticRenderFns } from "./PaymentTransactionShow.vue?vue&type=template&id=0b7b8ab8&"
import script from "./PaymentTransactionShow.vue?vue&type=script&lang=js&"
export * from "./PaymentTransactionShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports